module.exports = "/assets/site/images/mvmse_logo_bottom_trasparent.png?360401f3927a646bae7d497ee1f34956";